<template>
    <v-dialog v-model="dialog" persistent max-width="600px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="red"
            dark
            v-bind="attrs"
            v-on="on"
          >
            Отклонить заявление
          </v-btn>
        </template>
        <v-card>
          <v-card-title>
            <span class="headline">Отклонить заявление</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <ValidationObserver ref="observer">
              <form>
                   <ValidationProvider v-slot="{ errors }" name="messege" rules="required_messege_close">
                      <v-text-field
                        v-model="messege"
                        :error-messages="errors"
                        label="Причина"
                      ></v-text-field>
                   </ValidationProvider>
              </form>
              </ValidationObserver>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialog = false">Закрыть</v-btn>
            <v-btn color="green darken-1" text @click="submit">Сохранить</v-btn>

          </v-card-actions>
        </v-card>
      </v-dialog>
</template>

<script>
    import  Vue from 'vue'
    import { required} from 'vee-validate/dist/rules'
    import { extend, ValidationObserver, ValidationProvider} from 'vee-validate'

    extend('required_messege_close', {
      ...required,
      message: 'Поле "Причина" Не должно быть пустым',
    });
    export default {
      components: {
        ValidationProvider,
        ValidationObserver,
      },

      name: "messege_isClose",
      data: () => ({
        dialog: false,
      }),
      props: ['application_id','messege'],
      methods: {
        async submit() {
          await this.$refs.observer.validate().then(success => {
            if (!success) {
              return;
            }
            this.dialog = false;
            const {messege, application_id} = this;
            Vue.axios.post('operator/is_close/', {messege, application_id})
              .then(function () {
                console.log('SUCCESS!!');
              })
              .catch(function () {
                console.log('FAILURE!!');
              });
           this.$router.push('/operator_profile');
          })
        }
      }
    }
</script>

<style scoped>

</style>
